export enum CASE_STATUS {
  DRAFT = 'DRAFT',
  COMPLETED = 'COMPLETED',
}
